import { Person } from '@mui/icons-material';
import { useGridApiRef } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';

import { useLoggedInEmployeeId, useLoggedInUserRoles } from '~/components/Auth';
import { SolaForceDataGrid } from '~/components/SolaForceDataGrid';
import { useRolesListReportData } from '~/data/reports';
import {
  ReportDatasetLayout,
  ReportDatasetRowCount,
} from '~/scenes/PortalModules/Analytics/common';
import { ReportColumnsVisibility } from '~/scenes/PortalModules/Analytics/common/ReportColumnsVisibility';
import { ReportDataExport } from '~/scenes/PortalModules/Analytics/common/ReportDataExport';
import { ReportViewLayout } from '~/scenes/PortalModules/Analytics/common/ReportViewLayout';
import { useRolesListReport } from '~/scenes/PortalModules/Analytics/People/RolesListReport/useRolesListReport';

import { getRolesListReportType } from './useGetRolesListReportType';

export const RolesListReport = () => {
  const { t } = useTranslation();

  const loggedInEmployeeId = useLoggedInEmployeeId();
  const loggedInUserRoles = useLoggedInUserRoles();

  const apiRef = useGridApiRef();
  const reportType = getRolesListReportType(
    loggedInUserRoles,
    loggedInEmployeeId,
  );

  const { data, isLoading } = useRolesListReportData({
    reportType,
  });

  const { rows, columns, columnGroupingModel } = useRolesListReport({ data });

  return (
    <ReportViewLayout
      heading={t('laRoleList')}
      slots={{
        toolbar: {
          main: (
            <ReportDatasetLayout>
              <ReportDatasetRowCount
                count={rows.length}
                description={t('laTotalRecords')}
                icon={<Person />}
              />
            </ReportDatasetLayout>
          ),
          actions: (
            <>
              <ReportColumnsVisibility
                apiRef={apiRef}
                isLoading={isLoading}
                columnGroupingModel={columnGroupingModel}
              />
              <ReportDataExport
                title={t('laRoleList')}
                apiRef={apiRef}
                isLoading={isLoading}
              />
            </>
          ),
        },
      }}
    >
      <SolaForceDataGrid
        apiRef={apiRef}
        columns={columns}
        rows={rows}
        columnGroupingModel={columnGroupingModel}
        experimentalFeatures={{ columnGrouping: true }}
        loading={isLoading}
        density={'compact'}
        getRowId={(row) => row.employeeId}
        pinnedColumns={{
          left: ['employeeId', 'firstName', 'lastName'],
        }}
      />
    </ReportViewLayout>
  );
};
